import {
  LeaderboardMeData,
  LeaderboardResultItem,
} from 'src/models/leaderboard/_types';

export function computeMeResult(
  userId: string | number | undefined,
  similarResults: LeaderboardResultItem[],
  totalResults: number,
  sortAsc: boolean
): LeaderboardMeData | null {
  if (!userId) return null;

  const myResult = similarResults.find(
    (r) => r.id?.toString() === userId?.toString()
  );
  if (!myResult) return null;

  const rank = myResult.rank || 0;
  const numericRank = typeof rank === 'string' ? parseInt(rank, 10) : rank;
  const percentile =
    totalResults > 0 ? (totalResults - numericRank + 1) / totalResults : 0;

  let nextTier: string | null = null;
  if (numericRank === 1) {
    nextTier = "You're in the lead";
  } else if (similarResults.length > 0) {
    const similar = similarResults.filter((result) => {
      if (result.id?.toString() === userId?.toString()) return false;
      return sortAsc
        ? Number(result.value) <= Number(myResult.value)
        : Number(result.value) >= Number(myResult.value);
    });

    if (similar.length > 0) {
      let idx = Math.floor(Math.random() * similar.length);
      if (idx < 2 && similar.length > idx + 2) {
        idx = idx + 2;
      }
      const pick = similar[idx];
      if (pick) {
        const passing = similar.filter((result) =>
          sortAsc
            ? Number(result.value) >= Number(pick.value)
            : Number(result.value) <= Number(pick.value)
        ).length;
        const nextValue = sortAsc
          ? Number(pick.value) - 1
          : Number(pick.value) + 1;
        nextTier = `Pass ${passing} by hitting ${nextValue}`;
      }
    }
  }

  return {
    rank: myResult.rank,
    percentile,
    value: myResult.value,
    date: new Date(myResult.date * 1000),
    nextTier,
  };
}

export function formatExerciseTime(seconds: number, showHours = true): string {
  const totalSeconds = Math.abs(Math.round(seconds));
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = totalSeconds % 60;

  if (showHours && h > 0) {
    return `${h}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  }
  return `${m}:${s.toString().padStart(2, '0')}`;
}

export function convertUnits(value: number, from: string, to: string): number {
  const conversions: Record<string, Record<string, number>> = {
    lb: { kg: 0.453592 },
    kg: { lb: 2.20462 },
    ft: { m: 0.3048, yd: 0.333333, mi: 0.000189394, km: 0.0003048 },
    m: { ft: 3.28084, yd: 1.09361, mi: 0.000621371, km: 0.001 },
    yd: { ft: 3, m: 0.9144, mi: 0.000568182, km: 0.0009144 },
    mi: { ft: 5280, m: 1609.34, yd: 1760, km: 1.60934 },
    km: { ft: 3280.84, m: 1000, yd: 1093.61, mi: 0.621371 },
  };

  if (from === to) return value;
  const factor = conversions[from]?.[to];
  if (!factor) return value;
  return value * factor;
}
